// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.saltTabNextTrigger{all:unset;gap:var(--salt-spacing-100);flex:1;justify-content:center;align-items:center;display:flex}.saltTabNextTrigger:before{content:"";width:100%;height:100%;position:absolute;top:0;left:0}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
